var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 24 24","role":"presentation","focusable":"false","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}},[_c('path',{attrs:{"d":"M14 4H4v10H2V4a2 2 0 012-2h10v2m4 2H8a2 2 0 00-2 2v10h2V8h10V6m4 6v8a2 2 0 01-2 2h-8a2 2 0 01-2-2v-8a2 2 0 012-2h8a2 2 0 012 2m-2 3h-8v2h8v-2z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }